"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImporterLocationId = void 0;
var ImporterLocationId;
(function (ImporterLocationId) {
    ImporterLocationId["CITROEN_NORWAY"] = "700";
    ImporterLocationId["KIA_NORWAY"] = "772";
    ImporterLocationId["PEUGEOT_NORWAY"] = "791";
    ImporterLocationId["OPEL_NORWAY"] = "804";
    ImporterLocationId["MERCEDES_BENZ_NORWAY_TRANSPORTER"] = "808";
    ImporterLocationId["MERCEDES_BENZ_NORWAY_COMMERCIAL"] = "809";
    ImporterLocationId["MERCEDES_BENZ_NORWAY_PERSONAL"] = "817";
    ImporterLocationId["MERCEDES_BENZ_NORWAY_BUS"] = "818";
})(ImporterLocationId = exports.ImporterLocationId || (exports.ImporterLocationId = {}));
//# sourceMappingURL=bos-api.js.map